'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);

    this.onclose = function () {};

    this.data = {};
    this.models = [{ name: 'people' }, { name: 'relationships' }, { name: 'positions' }, { name: 'departments' }, { name: 'organisations' }, { name: 'logentries' }, { name: 'educations' }, { name: 'settings' }];
  }

  _createClass(MemoryStorage, [{
    key: 'open',
    value: function open() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var modelCount = 0;
        _this.models.forEach(function (model) {
          _this.create(model).then(function () {
            modelCount++;

            if (modelCount === _this.models.length) {
              resolve();
            }
          }, reject);
        });
      });
    }
  }, {
    key: 'status',
    value: function status() {
      return new Promise(function (resolve) {
        resolve('new');
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.onclose();
    }
  }, {
    key: 'create',
    value: function create(model) {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.data[model.name] = {};
        resolve();
      });
    }
  }, {
    key: 'readModel',
    value: function readModel(model) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.data[model.name]) {
          resolve(_this3.data[model.name]);
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'get',
    value: function get(model, id) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (_this4.data[model.name] && _this4.data[model.name][id]) {
          resolve(_this4.data[model.name][id]);
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'put',
    value: function put(model, data) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (!_this5.data[model.name]) {
          reject();
        }

        if (!data.id) {
          data.id = window.PRIM.getUUID();
        }

        _this5.data[model.name][data.id] = data;
        resolve();
      });
    }
  }, {
    key: 'delete',
    value: function _delete(model, id) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (_this6.data[model.name] && _this6.data[model.name][id]) {
          delete _this6.data[model.name][id];
          resolve();
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'writeModel',
    value: function writeModel(model, data) {
      var _this7 = this;

      return new Promise(function (resolve) {
        _this7.data[model.name] = data;
        resolve();
      });
    }
  }, {
    key: 'read',
    value: function read() {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        var data = {};
        var modelCount = 0;

        _this8.models.forEach(function (model) {
          _this8.readModel(model).then(function (modelData) {
            _this8.data[model.name] = modelData;

            modelCount++;

            if (modelCount === _this8.models.length) {
              resolve(data);
            }
          }, reject);
        });
      });
    }
  }, {
    key: 'write',
    value: function write(data) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        var dataCount = 0;

        _this9.models.forEach(function (model) {
          var totalCount = Object.keys(data[model.name]).length;

          if (totalCount > 0) {
            for (var id in data[model.name]) {
              var entry = data[model.name][id];
              _this9.writeModel(model, entry).then(function () {
                dataCount++;

                if (dataCount === totalCount) {
                  resolve();
                }
              }, reject);
            }
          } else {
            resolve();
          }
        });
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.data = null;
      this.init();
    }
  }]);

  return MemoryStorage;
}();

exports.default = MemoryStorage;


//////////////////
// WEBPACK FOOTER
// ./js/lib/storage/MemoryStorage.js
// module id = 4
// module chunks = 0